import React from 'react';
import { Box } from '@mui/material';

export const StaticLocationMap = ({ url, alt = 'Map of job ad locations' }) => {
  if (!url) return null;

  return (
    <Box
      component="img"
      src={url}
      alt={alt}
      loading="lazy"
      sx={{
        display: 'block',
        width: 1,
        height: 'auto',
        aspectRatio: '2 / 1',
        objectFit: 'cover',
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'border.jobAd',
      }}
    />
  );
};
